export default __webpack_public_path__ + "images/ExcelIcon.12af751c512873fec45d827aba199f2f.jpg";